export enum ColorThemeEnum {
  BLACK = 'black',
  WHITE = 'white',
  YELLOW = 'yellow',
  ORANGE = 'orange',
  ORANGE_REVERT = 'orange_revert',
  BLUE = 'blue',
  BLUE_REVERT = 'blue_revert',
  DARKBLUE = 'darkblue',
  DARKBLUE_REVERT = 'darkblue_revert',
  PURPLE = 'purple',
  PURPLE_REVERT = 'purple_revert',
  GREEN = 'green',
  GREEN_REVERT = 'green_revert',
  LIGHT_PURPLE = 'light_purple',
}

export const getColorThemeValues = () => Object.values(ColorThemeEnum) as [string, ...string[]];
